import { actionType } from './actions';

const initialState = {
    accounts: [],
    fetching: false,
    fetched: false,
    error: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionType.REQUESTED_ACCOUNT_DATA: {
            return {
                ...state,
                fetching: true,
                fetched: false,
                error: false
            };
        }

        case actionType.REJECTED_ACCOUNT_DATA: {
            return {
                ...state,
                fetching: false,
                fetched: true,
                error: true
            };
        }

        case actionType.FETCH_ACCOUNTS: {
            return {
                ...state,
                accounts: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/services/redux/employee/account/reducers.js